import { motion, useInView } from "framer-motion"
import { Link, graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"

const PressListing = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])
  const pressdata = useStaticQuery(graphql/* GraphQL */ `
    query PressQuery {
      allWpPressCategory {
        nodes {
          name
          slug
        }
      }
      allWpPress(sort: { date: DESC }) {
        nodes {
          title
          excerpt
          date(formatString: "D MMMM yyyy")
          pressCategory {
            nodes {
              name
              slug
            }
          }
          PressContent {
            pressLink
          }
        }
      }
    }
  `)

  const categories = pressdata.allWpPressCategory.nodes
  const allpressData = pressdata.allWpPress.nodes

  const exFixLimit = 6
  const [experinceLimit, setExLimit] = useState(exFixLimit)
  const [cExLimit, setCexLimit] = useState(exFixLimit)
  const [tabDetails, setTabDetails] = useState(
    allpressData.slice(0, exFixLimit)
  )
  const [tabOption, setTabOption] = useState("all")

  useEffect(() => {
    if (tabOption !== "all") {
      const arrayData = []
      for (var i = 0; i < allpressData.length; i++) {
        for (var j = 0; j < allpressData[i].pressCategory.nodes.length; j++) {
          if (allpressData[i].pressCategory.nodes[j].name === tabOption) {
            arrayData.push(allpressData[i])
          }
        }
      }
      setCexLimit(arrayData.length)
      setTabDetails(arrayData.slice(0, experinceLimit))
    } else {
      setCexLimit(allpressData.length)
      setTabDetails(allpressData.slice(0, experinceLimit))
    }
  }, [tabOption, experinceLimit, allpressData])

  const handleSelectChange = event => {
    setExLimit(exFixLimit)
    setTabOption(event.target.value)
  }

  if (module.hideSection === "no") {
    return (
      <section
        className={`bg-white-100 ${
          module.extraClass ? ` ${module.extraClass}` : ""
        }`}
        id={module.extraId}
      >
        <motion.div
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`press-listing py-60 ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid-md"
          >
            <motion.div
              variants={animFade}
              className="filter-listing flex flex-wrap items-center justify-end gap-x-4 gap-y-2 relative"
            >
              <span className="font-ositalic text-18 text-charcoal">
                Filter By:
              </span>
              <img
                className="absolute right-[12px] bottom-[19px]"
                src="https://kove.fluxfullcircle.com/app/uploads/2023/09/Vector-34.svg"
                alt=""
              />
              <select
                value={tabOption}
                onChange={handleSelectChange}
                className="border-1 border-charcoal rounded-2 w-[350px] py-[11px] px-15 !outline-none !bg-none !appearance-none"
              >
                <option value="all">All Properties</option>
                {categories.map((item, i) => {
                  return (
                    <option key={i} value={item.slug}>
                      {item.name}
                    </option>
                  )
                })}
              </select>
            </motion.div>
            <div className="flex flex-wrap -mx-20 lgscreen:mx-0 mt-45 gap-y-[40px] lgscreen:gap-y-[20px]">
              {tabDetails.length > 0 &&
                tabDetails.map((item, index) => {
                  return (
                    <div
                      className="lg:w-6/12 w-full px-20 lgscreen:px-0"
                      key={index}
                    >
                      <motion.div
                        variants={animFade}
                        className="border-1 border-charcoal rounded-2 py-50 px-60 lgscreen:p-20"
                      >
                        <div className="preheading mb-15">
                          {item.pressCategory.nodes.length > 0 &&
                            item.pressCategory.nodes.map((itemcat, k) => {
                              return (
                                <span
                                  className="font-ositalic text-16 text-charcoal"
                                  key={k}
                                >
                                  {itemcat.name}
                                  {k < item.pressCategory.nodes.length - 1 &&
                                    ","}{" "}
                                  {/* Add comma if not the last element */}
                                </span>
                              )
                            })}
                        </div>
                        {item?.title && <h5>{item.title}</h5>}
                        {item?.excerpt && (
                          <div className="content pt-15">
                            {parse(item.excerpt)}
                          </div>
                        )}
                        {item?.date && (
                          <div className="flex flex-wrap gap-x-[5px] pt-15">
                            <img
                              src="../images/event.svg"
                              className="relative -top-2"
                              width={12}
                              height={12}
                              loading="lazy"
                              alt="Event"
                            />
                            <span className="font-ositalic text-13">
                              {item.date}
                            </span>
                          </div>
                        )}
                        {item.PressContent?.pressLink && (
                          <div className="flex flex-wrap gap-x-3 mt-20">
                            <Link
                              to={item.PressContent.pressLink}
                              target="_blank"
                              className="btn btn-border flex flex-wrap items-center justify-center gap-x-2"
                            >
                              read more
                              <img
                                src="../images/open-in-new.svg"
                                width={12}
                                height={16}
                                loading="lazy"
                                alt="Open in New Tab"
                              />
                            </Link>
                          </div>
                        )}
                      </motion.div>
                    </div>
                  )
                })}
            </div>

            <motion.div
              variants={animFade}
              className="flex flex-wrap justify-center mt-60 lgscreen:mt-35"
            >
              {experinceLimit < allpressData.length &&
                cExLimit !== tabDetails.length &&
                tabDetails.length > 0 && (
                  <button
                    onClick={() => {
                      setExLimit(experinceLimit => experinceLimit + exFixLimit)
                    }}
                    className="btn btn-border opacity-50 smscreen:!w-full"
                  >
                    load more
                  </button>
                )}
            </motion.div>

            {tabDetails.length === 0 && (
              <div className="flex flex-wrap justify-center mt-75 lgscreen:mt-35">
                <div className="content text-center">
                  <h3>
                    No results found, please filter through our press again.
                  </h3>
                </div>
              </div>
            )}
          </motion.div>
        </motion.div>
      </section>
    )
  }
  return null
}

export default PressListing
export const PagePressListingFragment = graphql`
  fragment PagePressListingFragment on WpPage_Pagecontent_PageContent_PressListing {
    extraId
    extraClass
    hideSection
  }
`
